import clsx from 'clsx';
import styled from 'styled-components';

import { SocialShareButtonsConfig } from './SocialShareButtonConfigs';

import { useMediaQueryClasses } from '../hooks';

interface SocialShareButtonsProps {
  buttonConfig: SocialShareButtonsConfig[];
  iconSize: number;
  isInPage?: boolean;
  url: string;
}

const StyledSocialShareButtons = styled.div`
  &.social-share-buttons-wrapper {
    display: flex;

    &.in-page-share-buttons {
      display: flex;
      justify-content: flex-start;
      margin-top: ${({ theme }) => theme.spacing(3)};
      .social-share-button {
        margin-left: ${({ theme }) => theme.spacing(2)};
        margin-right: ${({ theme }) => theme.spacing(2)};
      }

      &.mobile {
        flex-direction: row;
      }
    }

    &.mobile {
      flex-direction: column;
    }
  }
`;

export const SocialShareButtons = (props: SocialShareButtonsProps) => {
  const { buttonConfig, iconSize, isInPage, url } = props;

  const mediaQueryClasses = useMediaQueryClasses();

  let buttonsClassName = 'tooltip-share-buttons';

  if (isInPage) {
    buttonsClassName = 'in-page-share-buttons';
  }

  return (
    <StyledSocialShareButtons className={clsx('social-share-buttons-wrapper', mediaQueryClasses, buttonsClassName)}>
      {buttonConfig.map((config, index) => {
        const { ButtonComponent, buttonProps, IconComponent, iconProps = {}, isRendered = true } = config;

        return isRendered ? (
          <div className="social-share-button" key={index}>
            <ButtonComponent url={url} {...buttonProps}>
              <IconComponent size={iconSize} round={true} className="social-share-buttons-icon" {...iconProps} />
            </ButtonComponent>
          </div>
        ) : null;
      })}
    </StyledSocialShareButtons>
  );
};
